import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Calendar } from 'lucide-react';
export function ContactFormSection() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate EmailJS submission
    // In a real scenario, you would use emailjs.sendForm('YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', e.currentTarget, 'YOUR_PUBLIC_KEY')
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitStatus('success');
      (e.target as HTMLFormElement).reset();
      // Reset status after 5 seconds
      setTimeout(() => setSubmitStatus('idle'), 5000);
    }, 1500);
  };
  return <section id="contacto" className="py-24 bg-dark-gray relative border-t border-white/5" data-id="element-1">
      <div className="container mx-auto px-6" data-id="element-2">
        <div className="max-w-4xl mx-auto" data-id="element-3">
          <div className="text-center mb-12" data-id="element-4">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-3xl md:text-5xl font-black text-electric-yellow mb-4 uppercase tracking-wide" data-id="element-5">
              Agenda Tu Diagnóstico
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-xl text-gray-300" data-id="element-6">
              Completa el formulario para analizar tu taller y mostrarte
              exactamente cómo llenaremos tus bahías.
            </motion.p>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-pure-black p-8 md:p-12 rounded-2xl border border-white/10 shadow-2xl" data-id="element-7">
            <form onSubmit={handleSubmit} className="space-y-6" data-id="element-8">
              {/* Personal Info */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-9">
                <div className="space-y-2" data-id="element-10">
                  <label htmlFor="name" className="text-sm font-medium text-gray-300" data-id="element-11">
                    Nombre Completo *
                  </label>
                  <input required type="text" id="name" name="name" className="w-full bg-dark-gray border border-white/20 rounded-md px-4 py-3 text-white focus:outline-none focus:border-electric-yellow transition-colors" placeholder="Ej. Juan Pérez" data-id="element-12" />
                </div>
                <div className="space-y-2" data-id="element-13">
                  <label htmlFor="email" className="text-sm font-medium text-gray-300" data-id="element-14">
                    Email *
                  </label>
                  <input required type="email" id="email" name="email" className="w-full bg-dark-gray border border-white/20 rounded-md px-4 py-3 text-white focus:outline-none focus:border-electric-yellow transition-colors" placeholder="juan@taller.com" data-id="element-15" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-16">
                <div className="space-y-2" data-id="element-17">
                  <label htmlFor="phone" className="text-sm font-medium text-gray-300" data-id="element-18">
                    Teléfono *
                  </label>
                  <input required type="tel" id="phone" name="phone" className="w-full bg-dark-gray border border-white/20 rounded-md px-4 py-3 text-white focus:outline-none focus:border-electric-yellow transition-colors" placeholder="(555) 123-4567" data-id="element-19" />
                </div>
                <div className="space-y-2" data-id="element-20">
                  <label htmlFor="company" className="text-sm font-medium text-gray-300" data-id="element-21">
                    Nombre del Taller/Compañía *
                  </label>
                  <input required type="text" id="company" name="company" className="w-full bg-dark-gray border border-white/20 rounded-md px-4 py-3 text-white focus:outline-none focus:border-electric-yellow transition-colors" placeholder="Mecánica AutoPro" data-id="element-22" />
                </div>
              </div>

              {/* Digital Presence */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-23">
                <div className="space-y-2" data-id="element-24">
                  <label htmlFor="website" className="text-sm font-medium text-gray-300" data-id="element-25">
                    Sitio Web (Opcional)
                  </label>
                  <input type="url" id="website" name="website" className="w-full bg-dark-gray border border-white/20 rounded-md px-4 py-3 text-white focus:outline-none focus:border-electric-yellow transition-colors" placeholder="https://www..." data-id="element-26" />
                </div>
                <div className="space-y-2" data-id="element-27">
                  <label htmlFor="instagram" className="text-sm font-medium text-gray-300" data-id="element-28">
                    Instagram de la Compañía (Opcional)
                  </label>
                  <input type="text" id="instagram" name="instagram" className="w-full bg-dark-gray border border-white/20 rounded-md px-4 py-3 text-white focus:outline-none focus:border-electric-yellow transition-colors" placeholder="@tallerautopro" data-id="element-29" />
                </div>
              </div>

              {/* Business Metrics */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-30">
                <div className="space-y-2" data-id="element-31">
                  <label htmlFor="current_clients" className="text-sm font-medium text-gray-300" data-id="element-32">
                    ¿Cuántos clientes nuevos tienes por semana? *
                  </label>
                  <select required id="current_clients" name="current_clients" className="w-full bg-dark-gray border border-white/20 rounded-md px-4 py-3 text-white focus:outline-none focus:border-electric-yellow transition-colors appearance-none" data-id="element-33">
                    <option value="" disabled selected data-id="element-34">
                      Selecciona una opción
                    </option>
                    <option value="0-5" data-id="element-35">0 - 5 clientes</option>
                    <option value="6-15" data-id="element-36">6 - 15 clientes</option>
                    <option value="16-30" data-id="element-37">16 - 30 clientes</option>
                    <option value="31+" data-id="element-38">Más de 30 clientes</option>
                  </select>
                </div>
                <div className="space-y-2" data-id="element-39">
                  <label htmlFor="goal_clients" className="text-sm font-medium text-gray-300" data-id="element-40">
                    ¿Cuál es tu meta de clientes nuevos por semana? *
                  </label>
                  <input required type="number" id="goal_clients" name="goal_clients" className="w-full bg-dark-gray border border-white/20 rounded-md px-4 py-3 text-white focus:outline-none focus:border-electric-yellow transition-colors" placeholder="Ej. 50" data-id="element-41" />
                </div>
              </div>

              {/* Marketing Experience */}
              <div className="space-y-2" data-id="element-42">
                <label className="text-sm font-medium text-gray-300" data-id="element-43">
                  ¿Has hecho publicidad antes (Facebook Ads, Google Ads)? *
                </label>
                <div className="flex gap-6 mt-2" data-id="element-44">
                  <label className="flex items-center gap-2 cursor-pointer" data-id="element-45">
                    <input type="radio" name="has_ads_experience" value="yes" className="text-electric-yellow focus:ring-electric-yellow bg-dark-gray border-white/20" required data-id="element-46" />
                    <span className="text-white" data-id="element-47">Sí</span>
                  </label>
                  <label className="flex items-center gap-2 cursor-pointer" data-id="element-48">
                    <input type="radio" name="has_ads_experience" value="no" className="text-electric-yellow focus:ring-electric-yellow bg-dark-gray border-white/20" required data-id="element-49" />
                    <span className="text-white" data-id="element-50">No</span>
                  </label>
                </div>
              </div>

              <div className="space-y-2" data-id="element-51">
                <label htmlFor="ad_spend" className="text-sm font-medium text-gray-300" data-id="element-52">
                  Si respondiste sí, ¿cuánto has gastado aproximadamente al mes?
                </label>
                <select id="ad_spend" name="ad_spend" className="w-full bg-dark-gray border border-white/20 rounded-md px-4 py-3 text-white focus:outline-none focus:border-electric-yellow transition-colors appearance-none" data-id="element-53">
                  <option value="" disabled selected data-id="element-54">
                    Selecciona una opción (si aplica)
                  </option>
                  <option value="<500" data-id="element-55">Menos de $500</option>
                  <option value="500-1000" data-id="element-56">$500 - $1,000</option>
                  <option value="1000-3000" data-id="element-57">$1,000 - $3,000</option>
                  <option value="3000+" data-id="element-58">Más de $3,000</option>
                </select>
              </div>

              {/* Submit Area */}
              <div className="pt-6 border-t border-white/10 flex flex-col items-center" data-id="element-59">
                <Button type="submit" disabled={isSubmitting} className="w-full md:w-auto min-w-[300px] text-lg py-5" data-id="element-60">
                  {isSubmitting ? 'ENVIANDO...' : 'SOLICITAR DIAGNÓSTICO GRATUITO'}
                </Button>

                {submitStatus === 'success' && <p className="mt-4 text-emerald-glow font-medium text-center" data-id="element-61">
                    ¡Gracias! Hemos recibido tu información. Nos pondremos en
                    contacto pronto.
                  </p>}
                {submitStatus === 'error' && <p className="mt-4 text-red-500 font-medium text-center" data-id="element-62">
                    Hubo un error al enviar. Por favor intenta de nuevo.
                  </p>}

                <div className="mt-8 text-center" data-id="element-63">
                  <p className="text-gray-400 text-sm mb-3" data-id="element-64">
                    ¿Prefieres agendar directamente?
                  </p>
                  <a href="https://calendar.app.google/gDsqAVqmwUYm" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-electric-yellow hover:text-white transition-colors font-medium underline underline-offset-4" data-id="element-65">
                    <Calendar className="w-4 h-4" data-id="element-66" />
                    Agendar cita en Google Calendar
                  </a>
                </div>
              </div>
            </form>
          </motion.div>
        </div>
      </div>
    </section>;
}